import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Media } from '../../../../../theme/Media.js';
import { Button } from '../../../../Controls/Button/index.js';
export const TableActionButton = memo(forwardRef(function TableActionButton({ children, ...props }, ref) {
    const isMobile = useMediaQuery({ query: Media.xsMax });
    return (_jsx(Button, { ...props, iconOnly: !isMobile, ghost: true, ref: ref, children: children }));
}));
